import { render, staticRenderFns } from "./fbaOperation.vue?vue&type=template&id=150e552a&scoped=true&"
import script from "./fbaOperation.vue?vue&type=script&lang=js&"
export * from "./fbaOperation.vue?vue&type=script&lang=js&"
import style0 from "./fbaOperation.vue?vue&type=style&index=0&id=150e552a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150e552a",
  null
  
)

export default component.exports